<template>
  <el-dialog title="新增销售线索" :visible.sync="visible" width="40%" >
    <el-form :model="data" :rules="rules" ref="addForm" label-width="90px">
      <el-form-item label="客户名称:" prop="customerId">
        <customer-select ref="customerSelectRef" :form-param="data" @change="customerChange"></customer-select>
        <span>如果无客户信息，请<el-button type="text" @click="skipCustomerList">前往添加</el-button></span>
      </el-form-item>
      <el-form-item label="联系人:" prop="contactId">
        <el-select v-model="data.contactId" placeholder="请选择联系人" clearable style="width:100%">
          <el-option v-for="dict in contactList" :key="dict.id" :label="dict.name" :value="dict.id"/>
        </el-select>
        <span>如果无联系人信息，请<el-button type="text" @click="skipContactList">前往添加</el-button></span>
      </el-form-item>
      <el-form-item label="负责人:" prop="assignUserId">
        <UserSelect v-model="data.assignUserId" placeholder="请选择线索负责人"></UserSelect>
      </el-form-item>
      <el-form-item label="线索来源:" prop="clueSource">
        <el-select v-model="data.clueSource" placeholder="请选择线索来源" allow-create filterable clearable style="width:100%">
          <el-option v-for="dict in sourceOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="采购需求:" prop="purchaseIntentionList">
        <el-select v-model="data.purchaseIntentionList" placeholder="请选择采购需求" multiple clearable style="width:100%">
          <el-option v-for="dict in purchaseIntentionOptions" :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="1000" show-word-limit v-model="data.remark" placeholder="请输入备注" clearable />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="submitting" @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" :disabled="submitting" @click="confirm">创建</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {addClue, checkCluePhoneNum} from "@/api/crm/clue";
import UserSelect from "@/views/crm/components/userSelect";
import {isPhone} from "@/utils/validate";
import {mapState} from 'vuex'
import {queryContactByCustomerId} from "@/api/crm/contact";
import {queryProductTypeList2} from "@/api/crm/contract";
import customerSelect from "@/views/crm/components/customerSelect";

export default {
  name: "AddClueDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      sourceOptions: [],
      contactList: [],
      purchaseIntentionOptions: [],
      submitting: false,
      rules: {
        customerId: [
          {required: true, message: '请选择客户名称', trigger: 'change'}
        ],
        contactId:  [
          {required: true, message: '请选择联系人', trigger: 'change'}
        ],
        clueSource: [
          {required: true, message: '请选择线索来源', trigger: 'change'}
        ],
        purchaseIntentionList: [
          {required: true, message: '请选择采购需求', trigger: 'change'}
        ],
        informantName: [
          {required: true, message: '请输入姓名', trigger: 'change'},
          {max: 32, message: '长度过长', trigger: 'change'}
        ],
        companyName: [
          {required: true, message: '请输入公司名称', trigger: 'change'},
          {max: 64, message: '长度过长', trigger: 'change'}
        ],
        informantMobile: [
          { validator: this.checkMobile, trigger: "change" }
        ],
        assignUserId: [
          {required: true, type: 'number', message: '请选择线索负责人', trigger: 'change'}
        ],
        remark: [
          {max: 1000, message: '备注最长1000个字符', trigger: 'change'}
        ]
      },
      data: {
        remark: null,
        clueSource: null,
        customerId: null,
        purchaseIntentionList: [],
        contactId: null,
        assignUserId: null
      }
    };
  },
  created() {
    this.getDicts("common_source").then(response => {
      this.sourceOptions = response.data;
    });
    queryProductTypeList2({}).then(response => {
      this.purchaseIntentionOptions = response.data || [];
    })
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    customerSelect
  },
  watch: {
    visible (val) {
      if (!val) {
        this.data.companyId = null
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open () {
      this.data.assignUserId = this.currentUserId
      this.visible = true
    },
    toDetailBlank(id) {
      this.$router.push("/crm/clue/detail/" + id);
    },
    checkMobile (rule, value, callback) {
      // 非必填
      if (!value) {
        callback()
      } else if (isPhone(value)) {
        // 填了公司名称，才去校验手机号。所以需要在填写公司名称后再手动触发下手机号校验
        if (this.data.companyName) {
          checkCluePhoneNum(
            {
              informantMobile: value,
              companyName: this.data.companyName
            }
          ).then( response => {
            if (response.data && response.data.id) {
              callback(new Error(response.data.id + '#error#' + response.data.informantName))
            } else {
              callback()
            }
          }).catch(error => {
            callback()
          })
        } else {
          callback()
        }
      } else {
        callback(new Error('格式不正确'))
      }
    },
    handleCompanyChange(companyName, companyId) {
      this.data.companyId = companyId ? companyId : ''
      this.$refs['addForm'].validateField('informantMobile')
    },
    confirm () {
      if (this.submitting) return
      this.submitting = true
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          addClue({...this.data}).then(response => {
            this.$emit('success')
            this.visible = false
            this.msgSuccess('销售线索创建成功');
          }).catch(() => {
          }).finally(() => {
            loading.close()
            this.submitting = false
          })
        } else {
          this.submitting = false
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    customerChange() {
      let param = {
        customerId: this.data.customerId
      }
      this.data.contactId = null
      queryContactByCustomerId(param).then(response => {
        this.contactList = response.data
      }).catch(error => {
      })
    },
    skipCustomerList() {
      this.$router.push("/crm/customer/manage");
    },
    skipContactList() {
      this.$router.push("/crm/contact/manage");
    }
  }
};
</script>
